<template>
  <div class="purchase-invitation">
    <div class="search-box">
      <a-input-search
        v-model="searchKey"
        :placeholder="$t('请输入您要搜索的关键词')"
        allowClear
        @search="onSearch"
        @change="onSearchChange"
      />
    </div>
    <div v-loading="loading" class="list-container">
      <ul v-if="list.length > 0">
        <li v-for="(item, index) in list" :key="index" class="list-item">
          <div class="item-top">
            <div class="title" :title="item.name">{{ item.name }}</div>
            <div class="price">{{ formatPrice(item) }}</div>
          </div>
          <div class="item-middle">
            <div class="status-tag" :class="getStatusClass(item.status)">
              {{ getPurchaseStatusText(item.status) }}
            </div>
          </div>
          <div class="item-bottom">
            <div class="item-date">{{ item.createTime }}发布</div>
            <div class="item-action">
              <a-button class="send-btn" size="small" @click="handleSend(item)">{{ $t('发送') }}</a-button>
            </div>
          </div>
        </li>
      </ul>
      <div v-else-if="!loading" class="empty-state">
        <a-empty :image="simpleImage" />
      </div>
    </div>
  </div>
</template>

<script>
import { getUserPurchaseList, supplierInvite } from '@/api/memberCenter/myPurchase'
import { Empty } from 'ant-design-vue'
import { mapActions, mapGetters } from 'vuex'
import { setSaveChat } from '@/api/pushSend'

export default {
  name: 'PurchaseInvitation',
  data() {
    return {
      searchKey: '',
      list: [],
      loading: false,
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      // Default query params
      current: 1,
      size: 20,
    }
  },
  computed: {
    ...mapGetters({
      token: 'token',
      currentSession: 'chat/currentSession',
      currentUser: 'chat/currentUser',
      otherUserInfo: 'chat/otherUserInfo',
      visitorUser: 'chat/visitorUser',
      IMLoginInfo: 'chat/IMLoginInfo',
      isWebIMLogin: 'chat/isWebIMLogin',
    }),
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    ...mapActions({
      addMessage: 'chat/addMessage',
    }),
    async fetchList() {
      this.loading = true
      try {
        const params = {
          current: this.current,
          size: this.size,
          key: this.searchKey,
          isUseful: 1,
          // Add other necessary params if any
        }
        const res = await getUserPurchaseList(params)
        if (res.code === 0 && res.data) {
          this.list = res.data.records || []
        } else {
          this.list = []
        }
      } catch (error) {
        console.error('Error fetching purchase list:', error)
        this.list = []
      } finally {
        this.loading = false
      }
    },
    onSearch() {
      this.current = 1
      this.fetchList()
    },
    onSearchChange(e) {
      if (e.target.value === '') {
        this.onSearch()
      }
    },
    // getStatusText(status) {
    //     // 1: 采购中, 2: 已采购, 4: 已下架
    //     const statusMap = {
    //         1: this.$t('待匹配'),
    //         2: this.$t('报价中'),
    //         3: this.$t('报价中'),
    //         4: this.$t('已采购'),
    //         5: this.$t('自主下架'),
    //         6: this.$t('平台下架'),
    //     };
    //     return statusMap[status] || this.$t('未知状态');
    // },
    getPurchaseStatusText(status) {
      const map = {
        1: this.$t('采购中'),
        2: this.$t('采购中'),
        3: this.$t('采购中'),
        4: this.$t('已采购'),
        5: this.$t('自主下架'),
        6: this.$t('平台下架'),
      }
      return map[status]
    },
    getStatusClass(status) {
      const statusMap = {
        1: 'status-ing',
        2: 'status-ing',
        3: 'status-ing',
        4: 'status-done',
        5: 'status-gray',
        6: 'status-gray',
      }
      return statusMap[status] || 'status-gray'
    },
    async handleSend(item) {
      try {
        const memunicode = this.otherUserInfo.memunicode || this.otherUserInfo.memUnicode
        if (!memunicode) {
          this.$message.error('无法获取用户信息，邀请失败')
          return
        }
        const res = await supplierInvite(item.purchaseCode, memunicode)
        if (res.code !== 0) {
          this.$message.error(res.msg || '邀请失败')
          return
        }

        const that = this
        const id = this.$WebIM.conn.getUniqueId() // Generate local message ID
        const msg = new this.$WebIM.message('txt', id) // Create text message

        const content = '[采购邀请]'

        const msgInfo = {
          id,
          from: this.currentUser.id || this.IMLoginInfo.ip,
          to: this.currentSession.id,
          contentsType: 'TEXT',
          data: content,
          time: new Date().getTime(),
          status: that.isWebIMLogin ? 'loading' : 'error',
          is_self: 1,
          sourceMsg: '[采购邀请]',
        }

        const ext = {
          yunhzhContentType: 'purchase',
          sendUrl:
            (that.currentUser.company && that.currentUser.company.logo) ||
            that.currentUser.avatar ||
            that.currentUser.selectedAvatarUrl ||
            '',
          sendName:
            (that.currentUser.company && that.currentUser.company.companyName) ||
            (that.currentUser.memberCard && that.currentUser.memberCard.contact) ||
            '',
          receiveUrl: that.otherUserInfo.pic || '',
          receiveName:
            that.otherUserInfo.companyName || that.otherUserInfo.contact || that.otherUserInfo.mchcompanyName || '',
          content,
          em_ignore_notification: '1',
          roleId: String(that.currentUser.roleId),
          memunicode: that.currentUser.memunicode,
          company: (that.currentUser.company && that.currentUser.company.companyName) || this.IMLoginInfo.ip || '',
          yunhzhContentProduct: { ...item },
        }

        msgInfo.ext = ext
        console.log(msgInfo, 'msgInfo', this.currentUser, 'currentUser')
        that.addMessage(msgInfo)

        msg.set({
          msg: content,
          to: that.otherUserInfo.huanxinId,
          ext,
          roomType: 'singleChat',
          success(id, serverMsgId) {
            msgInfo.id = serverMsgId
            that.$store.commit('chat/updateMessageStatus', {
              id,
              serverMsgId,
              status: 'success',
            })

            const saveInfo = {
              toMemberCode:
                that.otherUserInfo.memunicode || that.otherUserInfo.memUnicode || that.otherUserInfo.huanxinId,
              lastMessage: content,
            }

            if (!that.token) {
              saveInfo.visitorHuanxinId = that.visitorUser.huanxinId
            }

            setSaveChat(saveInfo)
          },
          fail(e) {
            console.log('Sending failed', e)
            that.$message.error(e.reason || e.type)
            that.$store.commit('chat/updateMessageStatus', {
              id,
              status: 'error',
            })
          },
        })

        this.$WebIM.conn.send(msg.body)
      } catch (err) {
        console.error('Error sending purchase invitation:', err)
      }
    },
    formatPrice(item) {
      // Priority: priceFlag+amount -> price -> budget -> '面议'
      // Check if amount is valid
      if (item.amount !== undefined && item.amount !== null) {
        if (Number(item.amount) === 0) return '面议'
        return (item.priceFlag || '¥') + Number(item.amount).toFixed(2)
      }
      if (item.price !== undefined && item.price !== null) {
        if (Number(item.price) === 0) return '面议'
        return `¥${Number(item.price).toFixed(2)}`
      }
      if (item.budget !== undefined && item.budget !== null) {
        // Assuming budgettype 0 is negotiable, or just checks value
        if (Number(item.budget) === 0) return '面议'
        return `¥${Number(item.budget).toFixed(2)}`
      }
      return '面议'
    },
  },
}
</script>

<style lang="scss" scoped>
.purchase-invitation {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 660px;
  width: 100%;
  overflow: hidden;
  /* Fix: Prevent overall container from expanding */
  background-color: #fff;

  .search-box {
    padding: 12px 16px;
    border-bottom: 1px solid #f0f0f0;

    ::v-deep .ant-input-search {
      .ant-input {
        background-color: #f8f9fb;
        border: 1px solid #eaedf1;
        border-radius: 16px;
        color: #333;

        &:hover,
        &:focus {
          border-color: #ff6600;
          background-color: #fff;
        }
      }
    }
  }

  .list-container {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    /* Fix: Prevent list items from pushing width */
    padding: 0 16px;

    ul {
      padding: 0;
      margin: 0;
      list-style: none;
    }

    .list-item {
      padding: 12px 0;
      border-bottom: 1px solid #f0f0f0;

      &:last-child {
        border-bottom: none;
      }

      .item-top {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 6px;

        .title {
          flex: 1;
          font-size: 14px;
          color: #333;
          font-weight: 500;
          @include text-ellipsis(2);
          margin-right: 8px;
          line-height: 1.4;
          min-width: 0;
          /* Fix: Allow flex item to shrink below content size */
        }

        .price {
          font-size: 14px;
          color: #ff6600;
          font-weight: 500;
          white-space: nowrap;
          flex-shrink: 0;
          /* Always show full price */
        }
      }

      .item-middle {
        margin-bottom: 8px;

        .status-tag {
          display: inline-block;
          font-size: 11px;
          padding: 0px 6px;
          border-radius: 2px;
          background-color: #fff;
          border: 1px solid #d9d9d9;
          color: #666;
          line-height: 18px;

          &.status-done {
            color: #52c41a;
            border-color: #52c41a;
            background-color: rgba(82, 196, 26, 0.05);
          }

          &.status-gray {
            color: #999;
            border-color: #d9d9d9;
          }
        }
      }

      .item-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .item-date {
          font-size: 12px;
          color: #999;
        }

        .item-action {
          .send-btn {
            background-color: #e6f1fc;
            color: #0076ff;
            border: none;
            border-radius: 2px;
            padding: 0 12px;
            height: 24px;
            line-height: 24px;
            font-size: 12px;

            &:hover,
            &:focus {
              background-color: #d0e6fa;
              color: #0060d0;
            }
          }
        }
      }
    }

    .empty-state {
      padding-top: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
